import "./HomePage.css";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import UserProfile from "../Context/UserProfile";
import FormButton from "../FormParts/FormButton";
import { getRequest, sendPostRequest } from "../Services/ContrectBackendAPI";
import { useState } from "react";
import PurchaseOrder from "../Context/PurchaseOrder";
import DelayMsgs from "../CommonPages/DelayMsgs";
import OtherData from "../Context/OtherData";

import ContractList from "./ContractList";
import Analytics from "./Analytics";


const HomePage = ({ setUserName,setPageTitle}) => {
    const navigate = useNavigate();
    const [displayName, setDisplayName] = useState();
    const [delayMsg, setDelayMsg] = useState([]);
    useEffect(() => {
        if (UserProfile.getLoginStatus() !== "1") {
            UserProfile.resetUser();
            navigate("/");
        }
        setPageTitle("Dashboard");
        //var d = OtherData.getData();
        // if (d.length > 0 && d.startsWith("{"))
        // {
        //     var dObj = JSON.parse(d);
        //     if (dObj.typeValue && dObj.typeValue.length > 0) {
        //         navigate("/Pay");
        //     }
        //     if (dObj.counterpartyDetails && dObj.counterpartyDetails.length>0)
        //     {
        //         navigate("/CustomAgreement");
                
        //     }
        //     if ( dObj.inviteOnly !== undefined) {
        //         navigate("/NewRFQ");

        //     }
        // }
        setUserName(UserProfile.getName());
        setDisplayName(UserProfile.getName());
    }, []);
    



    return (
        <div className="main-content" >
            
            <DelayMsgs msgList={delayMsg} setMsgList={setDelayMsg} />
            <div className="quick-actions">
                <div className="action-card" onClick={e => {
                    e.preventDefault();
                    navigate("/GeneratedByAI");
                }}>
                    <i className="fas fa-file-contract" style={{color:'#0F172A'}}></i>
                    <h3>Create Contract</h3>
                    <p>Start a new contract from template</p>
                </div>
                
            </div>

            {/* <Analytics /> */}

            <ContractList />
            

        </div>
	);
};

export default HomePage;
